/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useMemo, useEffect } from 'react';

import { Task } from 'API';

import falainaTenantId from 'consts/tenant';

import { useInfiniteTasksList } from 'queries/tasks.query';

import { sortList } from 'helpers/sortList';
import getNonNullableList from 'helpers/utils/getNonNullableList';

const useGetAllTasks = () => {
  const {
    data,
    isInitialLoading,
    isLoadingError,
    isFetching,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useInfiniteTasksList({
    enabled: true,
    filter: { tenantId: { eq: falainaTenantId } },
  });

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage, isFetchingNextPage]);

  const allTasks = useMemo(() => {
    const pages = data?.pages ?? [];

    const tempItems = pages.flatMap((page) =>
      getNonNullableList(page?.data?.listTasks?.items),
    );

    return tempItems as Partial<Task>[];
  }, [data?.pages]);

  const sorted = sortList(allTasks);

  return {
    allTasks: sorted,
    isAllTasksLoading: isInitialLoading,
    isAllTasksLoadingError: isLoadingError,
    isAllTasksFetching: isFetching,
    hasAllTasksNextPage: hasNextPage,
    isFetchingAllTasksNextPage: isFetchingNextPage,
  };
};

export default useGetAllTasks;
